import { Link } from '@remix-run/react'

type BreadcrumbItem = {
  label: string
  to: string
}

type Props = {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumbs({ items, className }: Props) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={
        className ?? 'flex flex-wrap items-center gap-2 text-foreground'
      }
    >
      {items.map((item, index) => (
        <div
          key={`${item.to}-${item.label}`}
          className="flex min-w-0 items-center gap-2"
        >
          {index > 0 && <span>{'>'}</span>}
          <Link
            to={item.to}
            className={`truncate text-foreground ${
              index === items.length - 1 ? 'underline' : ''
            }`}
          >
            {item.label}
          </Link>
        </div>
      ))}
    </nav>
  )
}
